import { render, staticRenderFns } from "./comments_list.vue?vue&type=template&id=5d0858ed&lang=pug&"
import script from "./comments_list.vue?vue&type=script&lang=js&"
export * from "./comments_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports